/* eslint-disable max-len */

import { organizationusersList } from "./apiSlice";
const MonitoringTemplates = organizationusersList.injectEndpoints({
    tagTypes: ['MonitoringTemplates'],
    endpoints: (builder) => ({
        addMonitorTemplates: builder.mutation({
            query: org => ({
                url: `/monitoring-templates`,
                method: 'POST',
                body: org
            }),
            invalidatesTags: ['MonitoringTemplates']
        }),
        getMonitorTemplates: builder.query({
            query: (searchParams) => `/monitoring-templates/list-template?${searchParams}`,
            providesTags: (result = [], error, arg) => error === undefined ? [

                'MonitoringTemplates',
                ...result?.data !== undefined && Array.isArray(result?.data) && result?.data?.map(({ _id }) => ({ type: 'MonitoringTemplates', id: _id }))
            ] : []

        }),
        getMonitorViewTemplates: builder.query({
            query: (id) => `/monitoring-templates/${id}`,

            providesTags: (result, error, arg) => [{ type: 'MonitoringTemplates', id: arg }],
            invalidatesTags: []
        }),
        editMonitorTemplates: builder.mutation({
            query: ({ id, body }) => ({
                url: id !== undefined ? `/monitoring-templates/${id}` : `/monitoring-templates/`,
                method: 'PATCH',
                body: body
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'MonitoringTemplates', id: arg._id }]
        }),
        exportMonitorTemplates: builder.mutation({
            query: ({ queryString, columns, dateformat }) => ({
                url: `monitoring-templates/export-template-list?${queryString}`,
                method: 'POST',
                body: { "columns": columns, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
            }),
        }),
        deleteTemplate: builder.mutation({
            query: (id) => ({
                url: `monitoring-templates/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'MonitoringTemplates', id: arg.id }]
        }),



    }),


    overrideExisting: false
})

export const { 
    useLazyGetMonitorViewTemplatesQuery, 
    useExportMonitorTemplatesMutation, 
    useEditMonitorTemplatesMutation, 
    useGetMonitorTemplatesQuery, 
    useAddMonitorTemplatesMutation, 
    useGetMonitorViewTemplatesQuery, 
    useDeleteTemplateMutation ,
} = MonitoringTemplates